import removeHtmlTags from "Utilities/removeHtmlTags";
/**
 * 
 * @param {string} text 
 * @param {number} characterLimit 
 * @returns {{isOverLimit: boolean, charactersLeft: number, valueTextOnly: string}}
 */
export function getTextIsOverLimit(text, characterLimit) {
  const valueTextOnly = removeHtmlTags(text);
  const charactersLeft = characterLimit - valueTextOnly?.length;

  const isOverLimit = charactersLeft < 0;

  return {isOverLimit, charactersLeft, valueTextOnly};
}
